<template>
  <div class="container date-select-wrapper" :style="toolbar ? 'position: relative !important; padding: 0px;' : ''">
    <v-date-picker
      :value="currentDate"
      @input="dateChange"
      :allowed-dates="allowedDates"
      :events="mainDates"
      event-color="green lighten-1"
      full-width
      :readonly="!$auth.authenticated"
      style="float: right;">
      <div class="flex-center">
        <i class="material-icons" style="color: #66BB6A; font-size: 0.8em;">fiber_manual_record</i>
        <span style="font-size: 0.8em; margin-left: 5px;">Main Model Update</span>
      </div>
      <div v-if="!this.$auth.authenticated" style="font-size: 0.9em; margin-top: 10px; text-align: center;">
        <span>Please <router-link :to="{ name: 'login' }">Login</router-link> to use this feature</span>
      </div>
    </v-date-picker>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

const props = {
  toolbar: {
    type: Boolean,
    required: false
  }
}

const computed = {
  ...mapGetters({
    currentDate: 'aggregateModels/currentDate',
    mainDates: 'aggregateModels/mainDates',
    dates: 'aggregateModels/dates',
    mobile: 'ux/mobile'
  })
}

const methods = {
  ...mapActions({
    setCurrentDate: 'aggregateModels/setCurrentDate',
    setHouseDate: 'aggregateModels/setHouseDate',
    setSenateDate: 'aggregateModels/setSenateDate'
  }),
  readableDate (date) {
    if (!date) return ''
    const split = date.split('-')
    const year = split[0].slice(-2)
    const newDate = split[1] + '/' + split[2] + '/' + year
    return newDate
  },
  dateChange (date) {
    if (this.$auth.authenticated) {
      this.setCurrentDate(date)
    }

    if (this.chamber === 'house') {
      this.setHouseDate(date)
    } else if (this.chamber === 'senate') {
      this.setSenateDate(date)
    } else {
      this.setHouseDate(date)
      this.setSenateDate(date)
    }
  },
  allowedDates (val) {
    return this.dates.includes(val)
  }
}

export default {
  props,
  computed,
  methods,
  data () {
    return {
      mainModelDates: []
    }
  }
}
</script>

<style>
.date-select-wrapper {
  padding: 80px 20px;
  position: fixed;
  top: 0px;
  right: 0px;
  overflow: auto;
  z-index: 600;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
}

.date-picker-table {
  height: auto !important;
}

.application .theme--light.picker .picker__title, .theme--light .picker .picker__title {
  display: none;
}

@media only screen and (max-width: 960px) {
  .date-select-wrapper {
    width: 100%;
  }
}

@media only screen and (min-width: 960px) {
  .picker .picker--date .card .picker--landscape .picker--full-width {
    box-shadow: none !important;
  }

  .card {
    box-shadow: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/DateSelect.vue